/**
 * KYC VARA onboarding. The form opens as a modal (KycVaraModal) over the current page;
 * KycVaraModalHost decides when it opens. Logic lives in useKycVaraFlow.
 * Buttons elsewhere call openKycVerification().
 */
export { default, KYC_VERIFICATION_PATH } from "./KycVaraModalHost";
export { openKycVerification, OPEN_KYC_VARA_EVENT } from "./openKycVerification";
